
// 将通讯录按照 ABCD字母的顺序排序
const sortObjByKey = (obj) => {
  const keys = Object.keys(obj).sort();
  const newObj = {};
  for (let i = 0; i < keys.length; i++) {
    const index = keys[i];
    newObj[index] = obj[index];
  }
  return newObj;
};

// 将File文件转成base64
const fileToDataUrl = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

// 将base64转成File
const dataURLtoFile = (dataurl, filename = "file") => {
  const arr = dataurl.split(",");
  const match = arr[0].match(/:(.*?);/) || undefined;
  const mime = match && match[1];
  const suffix = mime && mime.split("/")[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime,
  });
};

//实现将项目的图片转化成base64
const convertImgToBase64 = (
  url,
  callback,
  outputFormat
) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const img = new Image();
  img.crossOrigin = "Anonymous";
  img.onload = function () {
    canvas.height = img.height;
    canvas.width = img.width;
    ctx && ctx.drawImage(img, 0, 0);
    const dataURL = canvas.toDataURL(outputFormat || "image/png");
    callback.call(this, dataURL);
    // canvas = null;
  };
  img.src = url;
};

//实现将网络的图片转化成base64
const getBase64ByUrl = (
  src,
  callback,
  outputFormat
) => {
  const xhr = new XMLHttpRequest();
  xhr.open("GET", src, true);
  xhr.responseType = "arraybuffer";
  xhr.onload = function (e) {
    if (xhr.status === 200) {
      const uInt8Array = new Uint8Array(xhr.response);
      let i = uInt8Array.length;
      const binaryString = new Array(i);
      while (i--) {
        binaryString[i] = String.fromCharCode(uInt8Array[i]);
      }
      const data = binaryString.join("");
      const base64 = window.btoa(data);
      const dataUrl =
        "data:" + (outputFormat || "image/png") + ";base64," + base64;
      callback.call(this, dataUrl);
    }
  };

  xhr.send();
};

const getExplorer = () => {
  const explorer = window.navigator.userAgent,
    compare = function (s) {
      return explorer.indexOf(s) >= 0;
    },
    ie11 = (function () {
      return "ActiveXObject" in window;
    })();
  if (compare("MSIE") || ie11) {
    return "ie";
  } else if (compare("Firefox") && !ie11) {
    return "Firefox";
  } else if (compare("Chrome") && !ie11) {
    return "Chrome";
  } else if (compare("Opera") && !ie11) {
    return "Opera";
  } else if (compare("Safari") && !ie11) {
    return "Safari";
  }
};

const forMatID = (cardId) => {
  //加密身份证
  if (cardId) {
    return cardId.toString().slice(0, 9) + "*********";
  }
  return ''
};

const formatDate = (now) => {
  now = new Date(now)
  var year = now.getFullYear(),
    month = now.getMonth() + 1,
    date = now.getDate(),
    hour = now.getHours(),
    minute = now.getMinutes(),
    second = now.getSeconds();

  // return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
  return year + "-" + month + "-" + date;
}

const dateFormat = (f, t) => {// dateFormat('YYYY-MM-DD HH:mm:ss', 1589935485378) => 2020-05-20 08:44:53
      if (t > 0 && ((t).toString()).length == 10) {
          t *= 1000;
      }
      var d = t ? new Date(t) : new Date(), fd = ['YYYY', 'MM', 'DD', 'HH', 'mm', 'ss'];
      f = f || 'YYYY/MM/DD HH:mm:ss';
      [d.getFullYear(), d.getMonth() + 1, d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds()].forEach(function(n, i) {
          n = n.toString();
          f = f.replace(fd[i], (n[1] ? n : '0' + n));
      });
      return f;
  }

export {
  fileToDataUrl,
  convertImgToBase64,
  dataURLtoFile,
  getBase64ByUrl,
  sortObjByKey,
  getExplorer,
  forMatID,
  dateFormat,
  formatDate
};



// WEBPACK FOOTER //
// ./src/utils/index.js